// material-ui
import { CardActions } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import React from 'react'

import Circle from '@mui/icons-material/Circle'
import { Button, CardContent, Divider, Grid } from '@mui/material'
import TitleService from 'title-service'
import AnalyticsChartCard from 'ui-component/cards/AnalyticsChartCard'
import MainCard from 'ui-component/cards/MainCard'

import { ProcessJobState } from 'features/enumerations'

// assets
import * as autoThunks from 'features/auto-thunks'
import { useEffect } from 'react'

import Tooling from 'components/Tooling'
import { getUserClaims } from 'features/application/application-slice'
import { get_all_mediaProcessJob } from 'features/mediaProcessJob/mediaProcessJob-slice'
import { get_all_mediaProcessJobOverview } from 'features/mediaProcessJobOverview/mediaProcessJobOverview-slice'
import { useDispatch, useSelector } from 'react-redux'

// ================================|| UI LIST - SIMPLE LIST ||================================ //

export default function SimpleList() {
  // Generate Grid
  const theme = useTheme()
  let dispatch = useDispatch()
  let claims = useSelector(getUserClaims)
  let mediaProcessJob_list = useSelector(get_all_mediaProcessJob)
  let mediaProcessJobOverview_list = useSelector(
    get_all_mediaProcessJobOverview,
  )
  const [refreshArg, setRefreshArg] = React.useState(null)
  const [resetArg, setResetArg] = React.useState(null)

  useEffect(() => {
    if (claims?.player) {
      dispatch(
        autoThunks.retrieve_media_processing_job({ playerId: claims?.player }),
      )
    }
  }, [claims?.player, refreshArg])
  useEffect(() => {
    if (claims?.player) {
      dispatch(
        autoThunks.retrieve_media_processing_job_overview({
          playerId: claims?.player,
        }),
      )
    }
  }, [claims?.player, refreshArg])
  useEffect(() => {
    if (claims?.player && resetArg) {
      dispatch(
        autoThunks.reset_failed_processing_jobs({ playerId: claims?.player }),
      )
    }
  }, [claims?.player, resetArg])

  function main(comp: any): any {
    return (() => {
      let inProgressJobs = 0
      let jobsCompleted = 0
      let readyJobs = 0
      let failed = 0
      let initialJobs = 0
      let attempts = 0

      mediaProcessJobOverview_list.forEach((item) => {
        inProgressJobs += item.inProgressJobs
        jobsCompleted += item.jobsCompleted
        readyJobs += item.readyJobs
        initialJobs += item.initialJobs
        failed += item.failed
      })

      let jobs_complete = 0
      let jobs_failed = 0
      let jobs_inprogress = 0
      let jobs_initial = 0
      let jobs_ready = 0

      mediaProcessJob_list.forEach((item) => {
        attempts += item.attempts
        switch (item.processJobState) {
          case ProcessJobState.Complete:
            jobs_complete++
            break
          case ProcessJobState.Failed:
            jobs_failed++
            break
          case ProcessJobState.InProgress:
            jobs_inprogress++
            break
          case ProcessJobState.Initial:
            jobs_initial++
            break
          case ProcessJobState.Ready:
            jobs_ready++
            break
        }
      })

      return (
        <div style={{ color: 'black' }}>
          <MainCard title={TitleService('Media Processing')} content={false}>
            <CardActions sx={{ justifyContent: 'flex-end' }}>
              <Button
                onClick={() => {
                  setRefreshArg(Date.now())
                }}
                variant="text"
                size="small"
              >
                {TitleService('Refresh')}
              </Button>
              <Button
                onClick={() => {
                  setResetArg(Date.now())
                }}
                variant="text"
                size="small"
              >
                {TitleService('Reset failed')}
              </Button>
            </CardActions>
            <Divider />
            <CardContent>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} lg={4}>
                  <AnalyticsChartCard
                    chartData={{
                      height: 224,
                      type: 'bar',
                      options: {
                        chart: {
                          id: 'percentage-chart',
                          sparkline: {
                            enabled: true,
                          },
                        },
                        plotOptions: {
                          bar: {
                            columnWidth: '55%',
                            distributed: true,
                          },
                        },
                        dataLabels: {
                          enabled: false,
                        },
                        theme: { mode: 'dark' },
                        stroke: {
                          width: 0,
                        },
                        xaxis: {
                          categories: [
                            'In Progress',
                            'Completed',
                            'Ready',
                            'Failed',
                            'Initial',
                          ],
                        },
                      },
                      series: [
                        {
                          name: 'Ready Jobs',
                          data: [
                            inProgressJobs,
                            jobsCompleted,
                            readyJobs,
                            failed,
                            initialJobs,
                          ],
                        },
                      ],
                    }}
                    title="Media Processing"
                    listData={[
                      {
                        color: theme.palette.primary.main,
                        icon: <Circle color="inherit" fontSize="small" />,
                        value: inProgressJobs,
                        percentage: inProgressJobs,
                        state: 1,
                      },
                      {
                        color: theme.palette.success.dark,
                        icon: <Circle color="inherit" fontSize="small" />,
                        value: jobsCompleted,
                        percentage: jobsCompleted,
                        state: 1,
                      },
                      {
                        color: theme.palette.error.main,
                        icon: <Circle color="inherit" fontSize="small" />,
                        value: readyJobs,
                        percentage: readyJobs,
                        state: 0,
                      },
                      {
                        color: theme.palette.orange.dark,
                        icon: <Circle color="inherit" fontSize="small" />,
                        value: failed,
                        percentage: failed,
                        state: 1,
                      },
                      {
                        color: theme.palette.orange.dark,
                        icon: <Circle color="inherit" fontSize="small" />,
                        value: initialJobs,
                        percentage: initialJobs,
                        state: 1,
                      },
                    ]}
                  />
                </Grid>
                <Grid item xs={12} sm={12} lg={4}>
                  <AnalyticsChartCard
                    chartData={{
                      height: 224,
                      type: 'bar',
                      options: {
                        chart: {
                          id: 'percentage-chart',
                          sparkline: {
                            enabled: true,
                          },
                        },
                        plotOptions: {
                          bar: {
                            columnWidth: '55%',
                            distributed: true,
                          },
                        },
                        dataLabels: {
                          enabled: false,
                        },
                        theme: { mode: 'dark' },
                        stroke: {
                          width: 0,
                        },
                        xaxis: {
                          categories: [
                            'Complete',
                            'Failed',
                            'InProgress',
                            'Initial',
                            'Ready',
                          ],
                        },
                      },
                      series: [
                        {
                          name: 'Ready Jobs',
                          data: [
                            jobs_complete,
                            jobs_failed,
                            jobs_inprogress,
                            jobs_initial,
                            jobs_ready,
                          ],
                        },
                      ],
                    }}
                    title="Media Processing"
                    listData={[
                      {
                        color: theme.palette.primary.main,
                        icon: <Circle color="inherit" fontSize="small" />,
                        value: jobs_complete,
                        percentage: jobs_complete,
                        state: 1,
                      },
                      {
                        color: theme.palette.success.dark,
                        icon: <Circle color="inherit" fontSize="small" />,
                        value: jobs_failed,
                        percentage: jobs_failed,
                        state: 1,
                      },
                      {
                        color: theme.palette.error.main,
                        icon: <Circle color="inherit" fontSize="small" />,
                        value: jobs_inprogress,
                        percentage: jobs_inprogress,
                        state: 0,
                      },
                      {
                        color: theme.palette.orange.dark,
                        icon: <Circle color="inherit" fontSize="small" />,
                        value: jobs_initial,
                        percentage: jobs_initial,
                        state: 1,
                      },
                      {
                        color: theme.palette.orange.dark,
                        icon: <Circle color="inherit" fontSize="small" />,
                        value: jobs_ready,
                        percentage: jobs_ready,
                        state: 1,
                      },
                    ]}
                  />
                </Grid>
              </Grid>
            </CardContent>
            <Divider />
            <CardActions sx={{ justifyContent: 'flex-end' }}>
              <Button
                onClick={() => {
                  setRefreshArg(Date.now())
                }}
                variant="text"
                size="small"
              >
                {TitleService('Refresh')}
              </Button>
              <Button
                onClick={() => {
                  setResetArg(Date.now())
                }}
                variant="text"
                size="small"
              >
                {TitleService('Reset failed')}
              </Button>
            </CardActions>
          </MainCard>
          <Tooling />
        </div>
      )
    })()
  }

  let output_main = main(null)

  return output_main
}
